import { render, staticRenderFns } from "./PurchaseRecord.vue?vue&type=template&id=b4122028&scoped=true&"
import script from "./PurchaseRecord.vue?vue&type=script&lang=js&"
export * from "./PurchaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRecord.vue?vue&type=style&index=0&id=b4122028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4122028",
  null
  
)

export default component.exports